import React, { useState, useContext } from "react"
import { ReactComponent as SeatIcon} from '../../../assets/seat-icon.svg';
import { BetterControlledTextField, ControlledTextField} from "../../Core/Form/ControlledFields";
import { SkywatchTooltip } from "../../Core/Popover/SkywatchInformationTooltip";
import { useMediaQuery, useTheme } from '@material-ui/core';
import { QuoteContextStore } from '../../../context/QuoteContext/QuoteContext';


const AircraftSeatsField = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [open, setOpen] = useState(true)
    const {locked_quote} = useContext(QuoteContextStore)

    return (
            <SkywatchTooltip open={open} placement={isMobile ? 'top' : 'right'} onOpen={() => {
                if(isMobile) return;
                setOpen(true)
            }} onClose={() => {
                if(isMobile) return;
                setOpen(false)
            }} IconComponent={SeatIcon} text={<>A reduction of seats is premitted only if they are <span className="bold">permanently</span> removed from the aircraft</>}>
                <BetterControlledTextField
                onFocus={() => {
                    if(!isMobile) return;
                    setOpen(true)
                }} 
                onBlur={() => {
                    if(!isMobile) return;
                    setOpen(false)
                }}
                fullWidth name="total_seats" className="margin-top-8" placeholder="Seats" type="number" disabled={locked_quote}/>
            </SkywatchTooltip>
    )
}

export default AircraftSeatsField;